var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kkloading"},[_c('img',{style:(_vm.imgstyle),attrs:{"src":require("@/assets/imgs/app/loading.png"),"mode":""}}),_c('div',{style:(_vm.loadingTextStyle)},[_vm._v(_vm._s(_vm.loadingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }